{
  "WALLBOARD": {
    "LOADING": "Läser in telefonköer...",
    "NO_QUEUES": "Inga telefonköer hittades.",
    "NO_AGENTS": "Inga agenter online i den här kön.",
    "UNKNOWN_CALLER": "Okänd uppringare",
    "STATUS": "Status",
    "TIME": "Tid",
    "AGENT": "Agent",
    "EXTENSION": "Anknytning",
    "READY": "Redo agenter",
    "ON_CALL": "Agenter i samtal",
    "PAUSED": "Agenter på rast",
    "WAITING": "Väntande samtal",
    "MISSED_CALLS": "Missade samtal",
    "HANDLED_CALLS": "Hanterade inkommande samtal",
    "OUTBOUND_CALLS": "Hanterade utgående samtal",
    "AVAILABILITY": "Tillgänglighet",
    "AVAILABILITY_TOOLTIP": "Andel inkommande samtal som besvarats av agenter (samtal som togs emot)",
    "AGENTS_COUNT": "({onCall} i samtal / {total} totalt)",
    "NO_AVAILABLE": "(ingen online)",
    "WAITING_CALLERS_COUNT": "{count} väntar",
    "CALLER": "Uppringare",
    "NUMBER": "Nummer",
    "WAIT_TIME": "Väntetid",
    "ACTION": "Åtgärd",
    "PICKUP_CALL": "Svara",
    "PICKUP_SUCCESS": "Begäran om att svara på samtalet har skickats.",
    "PICKUP_ERROR": "Det gick inte att svara på samtalet. Försök igen.",
    "PICKUP_DISABLED_TOOLTIP": "Du kan inte svara på ett samtal medan du är i ett samtal eller offline.",
    "CHAT_STATUS": {
      "NO_ACCESS": "Ingen åtkomst"
    },
    "PHONE_STATUS": {
      "NO_ACCESS": "Ingen åtkomst"
    }
  }
}
